module.exports = __webpack_public_path__ + "assets/img/main_icon_carousel_arrow_right_hover.2e6db718.svg";